<template>
  <div class="w-full space-y-4 p-6" data-testid="rx-step-prescription-confirm">
    <Headline tag="h4" look="h3">{{
      $t('rxConfigurator.prescriptionValues.confirm.title')
    }}</Headline>
    <p>
      {{ $t('rxConfigurator.prescriptionValues.confirm.text') }}
    </p>

    <SightData
      class="mb-4 mt-1"
      :title="$t('rx.prescription.summary.sightDataTitle')"
      :date="prescriptionDate"
      :details="sightDataDetails"
      openable
      start-open
    >
      <template #actions>
        <CircleButton
          data-testid="rx-confirm-prescription-edit"
          :size="8"
          background-color-class="bg-white"
          background-color-hover-class="hover:bg-white"
          :aria-label="$t('rxbasketcardDefault.sightData.edit')"
          :label="$t('rxbasketcardDefault.sightData.edit')"
          :title="$t('rxbasketcardDefault.sightData.edit')"
          no-margin
          border-color="[#D7DDE3]"
          border-color-hover="black"
          @click="editPrescription"
        >
          <template #icon>
            <LazyIconFielmannEdit class="size-5" />
          </template>
        </CircleButton>
      </template>
    </SightData>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['step:goTo', 'ui:update'])

const { $i18n, $currentShop } = useNuxtApp()

const { prescriptionValues } = useRxPrescription()
const sightDataDetails = mapSightPrescriptionToSightData(
  prescriptionValues.value,
)
const prescriptionDate = computed(() => {
  const today = toLocaleDateTimeString(new Date(), $currentShop)
  return `${$i18n.t('rx.prescription.summary.from')} ${today}`
})

onMounted(() => {
  emit('ui:update', {
    mainAction: 'continue' as RxMainAction,
  })
})

const editPrescription = () => {
  const stepIndex = getConfStepIndexByMasterKey('editPrescription', true)
  emit('step:goTo', stepIndex)
}
</script>
